import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { submitDevicesBatchRequest, submitDevicesValidateBatchRequest, setStateDevices, cleanValidatedDevices, patchDevicesRequest } from '../../actions/devices';
import { devicesSelector } from '../../selectors/devices';
import CreateDevices from './CreateDevices';

const mapStateToProps = createStructuredSelector({
    devices: devicesSelector
});
const mapDispatchToProps = {
    submitDevicesBatchRequest,
    submitDevicesValidateBatchRequest,
    setStateDevices,
    cleanValidatedDevices,
    patchDevicesRequest,
    
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateDevices);